// Entidade única da plataforma nos dados estruturados: o nome exibido é sempre "Shopping do Bem".
export const SITE_URL = 'https://shoppingdobem.com.br';
export const ORG_ID = `${SITE_URL}/#organization`;
export const WEBSITE_ID = `${SITE_URL}/#website`;
export const SITE_LOGO = `${SITE_URL}/shopping-do-bem-search-logo.png`;

export const platformOrganization = {
  '@type': 'Organization',
  '@id': ORG_ID,
  name: 'Shopping do Bem',
  url: SITE_URL,
  logo: { '@type': 'ImageObject', url: SITE_LOGO },
  sameAs: ['https://www.instagram.com/shoppingdobem.br/', 'https://www.facebook.com/shoppingdobem'],
  parentOrganization: { '@type': 'Organization', name: 'Organização Promovendo o Bem' },
};

export const platformWebSite = { '@type': 'WebSite', '@id': WEBSITE_ID, name: 'Shopping do Bem', url: SITE_URL, publisher: { '@id': ORG_ID } };

export const offeredByPlatform = { '@id': ORG_ID };

/** Grafo com Organization + WebSite + WebPage ligados à marca. */
export function platformGraph(pageUrl: string, pageName: string, extra: Record<string, unknown>[] = []) {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      platformOrganization,
      platformWebSite,
      { '@type': 'WebPage', '@id': `${pageUrl}#webpage`, url: pageUrl, name: pageName, isPartOf: { '@id': WEBSITE_ID }, publisher: { '@id': ORG_ID } },
      ...extra,
    ],
  };
}
